export default {
  "film": [
    {
      name: "JOHN MOGENSEN - AS LONG AS I LIVE",
      slug: "john-mogensen-as-long-as-i-live",
      description1: "OLE BORNEDAL, DIRECTOR\nRASMUS THJELLESEN, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2017",
      images: ["1.jpg","1-1.jpg","1-2.jpg","1-3.jpg","1-4.jpg","1-5.jpg","1-6.jpg","1-7.jpg","1-8.jpg","1-9.jpg","1-10.jpg","1-11.jpg","1-12.jpg","1-13.jpg","1-14.jpg","1-15.jpg","1-16.jpg"]
    },
    {
      name: "ANTHROPOID",
      slug: "anthropoid",
      description1: "SEAN ELLIS, DIRECTOR \nMORGAN KENNEDY, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2015",
      images: ["2.jpg"]
    },
    {
      name: "MOUNTAINS AND STONES",
      slug: "mountains-and-stones",
      description1: "JOSEPH RUBEN, DIRECTOR\nLUCA TRANCHINO, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2015",
      images: ["3.jpg"]
    },
    {
      name: "PERSONAL SHOPPER",
      slug: "personal-shopper",
      description1: "OLIVIER ASSAYAS, DIRECTOR\nFRANCOIS LABARTHE, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2015",
      images: ["4.jpg"]
    },
    {
      name: "LA DANSEUSE",
      slug: "la-danseuse",
      description1: "STÉPHANIE DI GIUSTO, DIRECTOR\nCARLOS CONTI, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2015",
      images: ["5.jpg"]
    },
    {
      name: "SERENA, THE FALLING",
      slug: "serena-the-falling",
      description1: "SUSANNE BIER, DIRECTOR\nRICHARD BRIDGLAND, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2012",
      images: ["6.jpg"]
    },
    {
      name: "AGORA, THE FALLING",
      slug: "agora-the-falling",
      description1: "GUY HENDRIX DYAS, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2008",
      images: ["7.jpg"]
    },
    {
      name: "JAMES BOND - CASINO ROYAL",
      slug: "james-bond-casino-royal",
      description1: "MARTIN CAMPBELL, DIRECTOR\nPETER LAMONT, DESIGNER",
      description2: "MICHAL SOUN, ART DIRECTOR",
      year: "2006",
      images: ["8.jpg"]
    },
    {
      name: "DOOM",
      slug: "doom",
      description1: "ANDRZEJ BARTKOWIAK, DIRECTOR\nSTEVE SCOTT, DESIGNER",
      description2: "MICHAL SOUN, DRAFTSMAN",
      year: "2004",
      images: ["9.jpg"]
    }
  ],
  "commercials": [
    "CS_NERATOV_FM1.jpg",
    "CS_ZISOV-FM1.jpg",
    "COTE_D_OR_FM_1.jpg",
    "CRAYOLA_FM1.jpg",
    "IPHONE_FM1.jpg",
    "CUBUS_FM1.jpg",
    "GARNIER_FM1.jpg",
    "CANAL_PLAY_FM1.jpg",
    "NETFLIX_FM1.jpg",
    "NETFLIX_FM2.jpg",
    "NETFLIX_FM3.jpg",
    "AXE_FM1.jpg",
    "AXE_FM2.jpg",
    "COREGA_FM1.jpg",
    "LIDL_FM1.jpg",
    "CURRYS_FM1.jpg",
    "DIET_COKE_FM1.jpg",
    "HEINEKEN_FM1.jpg",
    "HP_FM1.jpg",
    "SONY_FM1.jpg",
    "VIVELL_FM1.jpg",
    "VIVELL_FM2.jpg",
    "SONY_FM2.jpg",
    "SONY_FM3.jpg"
  ],
  "series": [
    "MARS_FM1.jpg",
    "MARS_FM2.jpg",
    "MARS_FM3.jpg",
    "MARS_FM4.jpg",
    "CL_FM1.jpg",
    "CL_FM2.jpg",
    "Z_1864_FM1.jpg",
    "Z_1864_FM2.jpg",
    "Z_1864_FM3.jpg"
  ],
  "about": [

  ]
}